import { render, staticRenderFns } from "./BeginnerTutorial.vue?vue&type=template&id=bd09687e&scoped=true&"
import script from "./BeginnerTutorial.vue?vue&type=script&lang=js&"
export * from "./BeginnerTutorial.vue?vue&type=script&lang=js&"
import style0 from "./BeginnerTutorial.vue?vue&type=style&index=0&id=bd09687e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd09687e",
  null
  
)

export default component.exports